module.exports = __webpack_public_path__ + "img/MM.2d222720.svg";